import { Component, inject, OnInit }                           from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router }                              from '@angular/router';
import { MatError, MatFormField, MatLabel }                    from '@angular/material/form-field';
import { MatInput }                                            from '@angular/material/input';
import { MatProgressSpinner }                                  from '@angular/material/progress-spinner';

import { UserService }          from '../../../api/user/user.service';
import { asciiOnlyValidator }   from '../../../shared/validators/ascii-only.validator';
import { CardComponent }        from '../../../shared/components/card/card.component';
import { CardTitleComponent }   from '../../../shared/components/card/title/card-title.component';
import { CardContentComponent } from '../../../shared/components/card/content/card-content.component';
import { AutoFocusDirective }   from '../../../shared/directives/auto-focus.directive';
import { TrimFieldDirective }   from '../../../shared/directives/trim-field.directive';
import { CardActionsComponent } from '../../../shared/components/card/actions/card-actions.component';
import { ButtonComponent }      from '../../../shared/components/buttons/button.component';

@Component({
  templateUrl: './setup-name.component.html',
  imports: [ReactiveFormsModule, CardComponent, CardTitleComponent, CardContentComponent, MatFormField, MatLabel, MatInput, AutoFocusDirective, TrimFieldDirective, MatError, CardActionsComponent, ButtonComponent, MatProgressSpinner]
})
export class SetupNameComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);

  isLoading = false;
  currentQueryParams = {};
  namesForm = this.formBuilder.group(
    {
      firstName: ['', [Validators.required, asciiOnlyValidator()]],
      lastName: ['', [Validators.required, asciiOnlyValidator()]]
    }
  );

  private returnUrl: string;

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParamMap;
    this.returnUrl = queryParams.has('returnUrl') ? queryParams.get('returnUrl') : '/';
    this.currentQueryParams = {returnUrl: this.returnUrl};
  }

  saveFirstAndLastName() {
    if (!this.namesForm.valid || this.isLoading) {
      return;
    }
    this.isLoading = true;

    this.userService.updateUserData(this.namesForm.value).subscribe({
      next: () => this.router
        .navigate([this.returnUrl])
        .then(() => this.isLoading = false),
      error: () => this.isLoading = false
    });
  }
}
